import React from "react";
import { withStyles } from "@material-ui/core";
import { max, sum } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";

import CustomInput from "./CustomInput";

const styles = {
  incrementButton: {
    margin: "0px 12px",
    fontSize: "1.7em",
    fontWeight: 500,
    cursor: "pointer",
    userSelect: "none",
  },
  decrementButton: {
    fontSize: "2.5em",
  },
};

const IncrementalInput = (props) => {
  const { classes, name, value = 0, handleChange } = props;

  return (
    <Grid container alignItems="center" className="height-100">
      <Grid
        item
        className={clsx(classes.incrementButton, classes.decrementButton)}
        onClick={() => handleChange(max([0, sum([value, -1])]))}
      >
        -
      </Grid>
      <Grid item style={{ width: "50px" }}>
        <CustomInput
          name={name}
          value={value}
          onChange={(e) => handleChange(max([0, parseInt(e.target.value)]))}
        />
      </Grid>
      <Grid
        item
        className={classes.incrementButton}
        onClick={(e) => handleChange(sum([value, 1]))}
      >
        +
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(IncrementalInput);
